import React from 'react';
import LayoutRenderer from '../components/LayoutRenderer';
import { useLayout } from '../hooks/useLayout';
import { DEFAULT_LAYOUTS } from '../data/defaultLayouts';

/**
 * Pagina generica gestita dall'admin via "Layout pagine".
 * Usa il layout salvato in backend, oppure quello di default.
 */
export default function LayoutPage({ slug }) {
  const { blocks } = useLayout(slug, DEFAULT_LAYOUTS[slug] || []);
  return (
    <div data-testid={`layout-page-${slug}`}>
      <LayoutRenderer blocks={blocks} />
    </div>
  );
}
